var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.226 26.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4285f4;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39,19H10.23A4.243,4.243,0,0,0,6,23.23V41a4.243,4.243,0,0,0,4.23,4.23H39A4.243,4.243,0,0,0,43.226,41V23.23A4.243,4.243,0,0,0,39,19Zm2.538,22A2.546,2.546,0,0,1,39,43.535H10.23A2.546,2.546,0,0,1,7.692,41V31.268H41.534Zm0-15.652H7.692V23.23a2.546,2.546,0,0,1,2.538-2.538H39a2.546,2.546,0,0,1,2.538,2.538Z",
    transform: "translate(-6 -19)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.2c1bba5e15cc5cc76f0e92be71f59467.svg";
export { ForwardRef as ReactComponent };